import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import { confirmAlert } from "react-confirm-alert";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";

import styles from "../../../styles/management.module.css";
import { usersActions } from "../../store";
import { useNavigate } from "react-router";
import Spinner from "../../spinner";
import Conf from "../../../conf";

let user;

const Edit = () => {
    const history = useNavigate();
    const Dispatch = useDispatch();

    const { UserID } = useParams();
    const isNew = UserID === "new";

    const users = useSelector((state) => Object.values(state.users.items));

    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [pass, setPass] = useState("");
    const [phone, setPhone] = useState("");
    const [wait, set_wait] = useState(false);

    const update = () => {
        fetch(`${Conf.server_address}/users?page=1&start=0&limit=25`, {
            method: "GET",
            headers: { "Content-Type": "application/json", accept: "application/json" },
            credentials: "include",
            cache: "no-cache",
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => Dispatch(usersActions.refresh(response)));
    };

    useEffect(() => {
        if (users.length === 0) history("/management/users");
        else if (!isNew) {
            const UserID_ = parseInt(UserID);
            user = users.find((Row) => Row.id === UserID_);
            setName(user.name);
            setUsername(user.email);
            setPhone(user.phone);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const save = () => {
        if (name.length === 0) NotificationManager.error("لطفا نام را وارد کنید", "", 2500);
        else if (username.length === 0) NotificationManager.error("لطفا نام کاربری را وارد کنید", "", 2500);
        else if (isNew && pass.length === 0) NotificationManager.error("لطفا گذرواژه را وارد کنید", "", 2500);
        else if (isNew) {
            let data = {
                id: -1,
                name: name,
                email: username,
                password: pass,
                phone: phone,
                readonly: false,
                administrator: false,
                disabled: false,
            };
            set_wait(true);
            fetch(`${Conf.server_address}/users`, {
                method: "POST",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            })
                .then((response) => {
                    return response.status === 200 ? response.json() : { error: response.status };
                })
                .then((response) => {
                    set_wait(false);

                    if (response.error) {
                        NotificationManager.error("این کاربر موجود میباشد", "", 2500);
                    } else {
                        NotificationManager.success("کاربر با موفقیت اضافه شد", "", 4000);
                        update();
                        user = response;
                        setName(user.name);
                        setUsername(user.email);
                        setPhone(user.phone);
                        history(`/management/users/edit/${response.id}`);
                    }
                });
        } else {
            set_wait(true);
            let data = {
                ...user,
                name: name,
                email: username,
                password: pass,
                phone: phone,
            };
            fetch(`${Conf.server_address}/users/${user.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            })
                .then((response) => {
                    return response.status === 200 ? response.json() : { error: response.status };
                })
                .then((response) => {
                    if (response.error) {
                        NotificationManager.error("این کاربر موجود میباشد", "خطا در بروزرسانی", 2500);
                    } else {
                        NotificationManager.success("کاربر با موفقیت بروزرسانی شد", "", 4000);
                        set_wait(false);
                    }
                });
        }
    };

    const deleteConfirm = () => {
        if (isNew) {
            history("/management/users");
        } else {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className={styles.custom_ui}>
                            <h1>آیا از حذف کاربر "{name}" مطمعن هستید ؟</h1>
                            <button onClick={onClose}>خیر</button>
                            <button
                                onClick={() => {
                                    set_wait(true);

                                    onClose();

                                    fetch(`${Conf.server_address}/users/${user.id}`, {
                                        method: "DELETE",
                                        headers: { "Content-Type": "application/json", accept: "*/*" },
                                        credentials: "include",
                                    }).then((response) => {
                                        if (response.status === 204) {
                                            NotificationManager.success("کاربر با موفقیت حذف شد", "", 4000);
                                            history("/management/users");
                                            set_wait(false);
                                        } else {
                                            NotificationManager.error("خطا در حذف کاربر", "", 2500);
                                        }
                                    });
                                }}
                            >
                                بله
                            </button>
                        </div>
                    );
                },
            });
        }
    };

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <div className={styles.headerRight}>
                    کاربران{" > "}
                    {isNew ? "کاربر جدید" : name}
                </div>
                <div className={styles.headerLeft} onClick={() => history("/management/users")}>
                    <KeyboardArrowLeftIcon className={styles.exitIcon} />
                    بازگشت
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.contents2}>
                    <div className={styles.form}>
                        <div className={styles.row}>
                            <div className={styles.clearfix}>
                                <label for="name" className={styles.label}>
                                    نام:
                                </label>
                                <input type="text" id="name" className={styles.inputPhone} value={name} onChange={(event) => setName(event.target.value)} />
                            </div>
                            <div className={styles.clearfix}>
                                <label for="id" className={styles.label}>
                                    نام کاربری:
                                </label>
                                <input type="id" className={styles.inputPhone} value={username} onChange={(event) => setUsername(event.target.value)} />
                            </div>
                        </div>

                        <div className={styles.row}>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>گذرواژه:</label>
                                <input type="text" className={styles.inputPhone} value={pass} onChange={(event) => setPass(event.target.value)} />
                            </div>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>تلفن :</label>
                                <input type="phone" className={styles.inputPhone} value={phone} onChange={(event) => setPhone(event.target.value)} />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.clearfix} style={{ width: "97%" }}>
                                <Button className={styles.saveUsers} style={{ marginLeft: "15px" }} variant="contained" component="label" onClick={() => !wait && save()}>
                                    <Spinner wait={wait} center={true} height={20}>
                                        {isNew ? "+ افزودن" : "ویرایش"}
                                    </Spinner>
                                </Button>
                                <Button className={styles.removeUsers} variant="contained" component="label" onClick={() => !wait && deleteConfirm()}>
                                    <Spinner wait={wait} center={true} height={20}>
                                        {isNew ? "بیخیال" : "حذف"}
                                    </Spinner>
                                </Button>
                                {isNew ? (
                                    []
                                ) : (
                                    <Button className={styles.devicesUsers} variant="contained" component="label" onClick={() => history(`/management/users/edit/${user.id}/devices`)}>
                                        دستگاه ها
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edit;
